import React, { useEffect, useState } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { ImageRequest, PropertyImage } from "@10x/dubai-rest-api/dist/property_images/entity";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { fetchImage, getImageRequest, getPropertyImageUrl, ImageView } from "./PropertyPhotos";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Navigation, Thumbs } from "swiper";
import { Swiper as SwiperClass } from "swiper/types";
import { JQModal } from "../Popup/Utils";
import { deleteImage, exToMessage, setDefaultImage } from "@10x/dubai-rest-api/dist/property_images/api";
import { showMessage } from "@my-dld/utils/UIUtils";
import { RenderLoading } from "../RTRegistration/AddPartyPopup";
import { shareFiles } from "@my-dld/utils/Utils";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

SwiperCore.use( [ Navigation, Thumbs ] );

export interface DownloadImage {
	url?: string;
	error?: string;
}

interface Props {
	property: AssetCard;
	images: PropertyImage[];
	position: number;
	defPosition: number;
	onDismiss: () => void;
	onDelete: ( images: PropertyImage[] ) => void;
	onPrimary: ( images: PropertyImage[] ) => void;
}

interface State {
	isLoading: boolean;
	images: PropertyImage[];
	position: number;
	defPosition?: number;
	showDelete: boolean;
}

function PropertyPhotosModal( props: Props ) {
	const [ state, setState ] = useState<State>( {
		isLoading: false,
		images: props.images,
		position: props.position,
		defPosition: props.defPosition,
		showDelete: false,
	} );
	const [ swiper, setSwiper ] = useState<SwiperClass>();
	const [ thumbsSwiper, setThumbsSwiper ] = useState<SwiperClass>();

	useEffect( () => {
		if ( swiper && thumbsSwiper ) {
			swiper.slideTo( state.position );
			thumbsSwiper.slideTo( state.position );
			swiper.on( "slideChange", ( swiper: SwiperClass ) => {
				setState( prevState => ( {
					...prevState,
					position: swiper.activeIndex,
				} ) );
			} );
		}
		return () => {
			JQModal( "PhotoDeleteModal" ).hide();
			JQModal( "PropertyPhotosModal" ).hide();
		};
	}, [ swiper, thumbsSwiper ] );

	const showLoading = ( show: boolean ) => {
		setState( prevState => ( {
			...prevState,
			isLoading: show,
		} ) );
	};

	const onPrimary = () => {
		showLoading( true );
		const image = state.images[ state.position ];
		const req: ImageRequest | undefined = getImageRequest( props.property );
		if ( req ) {
			const defReq: ImageRequest = { ...req, id: image.id, source: image.metadata.source };
			setDefaultImage( defReq ).then( r => {
				const nImages = r.data;
				updateImages( nImages, state.position );
				props.onPrimary( nImages );
			} ).catch( e => {
				showLoading( false );
				exToMessage( e ).then( message => {
					showMessage( message.error );
				} );
			} );
		}
	};

	const showDeleteConfirm = ( show: boolean ) => {
		if ( !show ) {
			JQModal( "PhotoDeleteModal" ).hide();
		}
		setState( prevState => ( {
			...prevState,
			showDelete: show,
		} ) );
	};

	const onDeleteConfirm = () => {
		JQModal( "PhotoDeleteModal" ).hide();
		setState( prevState => ( {
			...prevState,
			isLoading: true,
			showDelete: false,
		} ) );
		onDeleteImage();
	};

	const onDeleteImage = () => {
		const image = state.images[ state.position ];
		const req: ImageRequest | undefined = getImageRequest( props.property );
		if ( req ) {
			const delReq: ImageRequest = { ...req, id: image.id, source: image.metadata.source };
			deleteImage( delReq ).then( r => {
				const nImages = r.data;
				const position = ( nImages.length !== 0 && nImages.length > state.position ) ? state.position : state.position - 1;
				updateImages( nImages, position );
				props.onDelete( nImages );
			} ).catch( e => {
				showLoading( false );
				if ( e.code === 404 ) {
					updateImages( [], 0 );
				} else {
					exToMessage( e ).then( message => {
						showMessage( message.error );
					} );
				}
			} );
		}
	};

	const updateImages = ( images: PropertyImage[], position: number ) => {
		swiper?.slideTo( position );
		thumbsSwiper?.slideTo( position );
		setState( prevState => ( {
			...prevState,
			isLoading: false,
			position: position,
			images: images,
		} ) );
	};

	const onShare = () => {
		showLoading( true );
		const image = state.images[ state.position ];
		shrePropertyPhotos( [ image ], () => {
			showLoading( false );
		}, props.property );
	};

	const onDownload = () => {
		showLoading( true );
		const image = state.images[ state.position ];
		downloadPropertyPhotos( [ image ], () => {
			showLoading( false );
		}, props.property );
	};

	const currentImage = state.images[ state.position ];
	const isFromWallet = currentImage.metadata.source === "wallet";
	const isMainImg = ( props.defPosition === state.position );
	return <>
		<Popup
			id={ "PropertyPhotosModal" }
			autoOpenMount={ true }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" }
			title={ Strings.property_photos }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			showIcon={ false }
			modalBodyContainer={ "modal-body overflow-hidden" }
			onDismiss={ props.onDismiss }>
			<>
				<Swiper
					onSwiper={ setSwiper }
					thumbs={ { swiper: thumbsSwiper } }
					navigation={ true }
					spaceBetween={ 30 }
					className="swiper pSwiperMainGallery">
					{ state.images.map( ( image: PropertyImage, index: number ) => {
						const imageUrl = getPropertyImageUrl( image, props.property );
						return <SwiperSlide key={ `${ index }-${ image.id }` }>
							<ImageView imageUrl={ imageUrl }/>
						</SwiperSlide>;
					} ) }
					<div className="more-option">
						{/*{ !isMainImg && <button className="btn btn-link pshare-images"
                                                onClick={ onPrimary }>{ Strings.set_as_main_photo }</button> }*/ }
						<div>
							<button
								className="btn btn-link btn-sm pdownload-image"
								onClick={ onDownload }>{ Strings.download }</button>
							{/*{ isShareSupport() && <button className="btn btn-link btn-sm pshare-image"
                                                          onClick={ onShare }>{ Strings.share }</button> }*/ }
							{ ( !isMainImg && isFromWallet ) && <button
								type="button" className="btn btn-link btn-sm img-delete-option"
								onClick={ () => showDeleteConfirm( true ) }><i className="fa fa-trash-alt"/>
							</button> }
						</div>
					</div>
				</Swiper>
				<Swiper
					onSwiper={ setThumbsSwiper }
					spaceBetween={ 10 }
					slidesPerView={ 6 }
					observer={ true }
					className="swiper pSwiperMainGalleryThumbnail">
					{ state.images.map( ( image: PropertyImage, index: number ) => {
						const imageUrl = getPropertyImageUrl( image, props.property );
						return <SwiperSlide key={ `thumb-${ index }-${ image.id }` }>
							<ImageView imageUrl={ imageUrl }/>
						</SwiperSlide>;
					} ) }
				</Swiper>
			</>
		</Popup>
		{ state.showDelete && <Popup
			id={ "PhotoDeleteModal" }
			autoOpenMount={ true }
			modalSubContainer={ "modal-dialog modal-dialog-centered" }
			title={ Strings.property_photos }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			showIcon={ false }
			modalFooterContainer={ "modal-footer d-flex justify-content-center" }
			footer={ <>
				<button
					className="btn btn-grey btn_style1 font-size14"
					type="button"
					onClick={ () => showDeleteConfirm( false ) }>{ Strings.no }</button>
				<button
					className="btn btn_1 btn_style1 font-size14"
					type="button" onClick={ onDeleteConfirm }>{ Strings.yes }</button>
			</> }
			onDismiss={ () => showDeleteConfirm( false ) }>
			<div className="cancel-icon">
				<i className="fa fa-times"/>
			</div>
			<p className="text-center">{ Strings.property_photo_delete_confirmation }</p>
		</Popup> }
		{ state.isLoading && <RenderLoading/> }
	</>;
}

export function shrePropertyPhotos( images: PropertyImage[], onFinish: () => void, property?: AssetCard ) {
	if ( images && images.length && property ) {
		const filesPromises: Promise<File>[] = [];
		for ( const image of images ) {
			const imageUrl = getPropertyImageUrl( image, property );
			filesPromises.push( fetchImage( imageUrl ).then( ( blob: Blob ) => {
				const file = new File( [ blob ], image.metadata.name );
				return Promise.resolve( file );
			} ) );
		}
		Promise.all( filesPromises ).then( ( files: File[] ) => {
			onFinish();
			shareFiles( Strings.property_photos, files );
		} );
	}
}

export function downloadPropertyPhotos( images: PropertyImage[], onFinish: () => void, property?: AssetCard ) {
	if ( images && images.length && property ) {
		const downloadPromises: Promise<{ name: string, url: string }>[] = [];
		for ( const image of images ) {
			const imageUrl = getPropertyImageUrl( image, property );
			downloadPromises.push( fetchImage( imageUrl ).then( ( blob: Blob ) => {
				const url = URL.createObjectURL( blob );
				return Promise.resolve( { name: image.metadata.name, url: url } );
			} ).catch( e => {
				return Promise.resolve( { name: "", url: "" } );
			} ) );
		}
		Promise.all( downloadPromises ).then( ( data: { name: string, url: string }[] ) => {
			data.forEach( ( item: { name: string, url: string }, index: number ) => {
				setTimeout( () => {
					if ( !isEmptyStringOrNull( item.url ) ) {
						const link = document.createElement( "a" );
						link.href = item.url;
						link.download = item.name;
						document.body.appendChild( link );
						link.click();
						link.parentNode?.removeChild( link );
					}
					if ( index === data.length - 1 ) {
						onFinish();
					}
				}, index * 1000 );
			} );
		} );
	}
}

export default PropertyPhotosModal;
